import axios from "axios";
import { NODE_BASE_URL, getAxiosOptions } from "./serviceHelper";

export const queryService = {
  getQuery: async (user, processId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/data-entry/query/process/${processId}`,
        getAxiosOptions(user)
      )
    ).data;
  },
  saveQuery: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/data-entry/query/add-query`,
        payload,
        getAxiosOptions(user)
      )
    ).data;
  },
  deleteQuery: async (user, queryId) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/data-entry/query/delete/${queryId}`,
        getAxiosOptions(user)
      )
    ).data;
  },
};
